import { useEffect, useRef, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ModalDialog from "../../../shared/ModalDialog";
import Message from "../../../../i18n/Message";
import label from "../../../../i18n/label";
import { createGateway } from "../store/gatewayActionCreators";
import { linkToGateway } from "../../../../routes";

const CreateGatewayDialog = ({ onClose }) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const inputRef = useRef(null);
  const formRef = useRef(null);
  const dispatch = useDispatch();
  const intl = useIntl();
  const nav = useNavigate();
  const { workspaceId } = useParams();

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const onCreate = (e) => {
    e.preventDefault();
    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      return;
    }

    setLoading(true);
    const data = {
      name,
      routingStrategy: "LATENCY_BASED",
      models: [],
    };

    dispatch(
      createGateway(
        intl,
        workspaceId,
        data,
        (gateway) => {
          setLoading(false);
          onClose();
          nav(linkToGateway(workspaceId, gateway.uid));
        },
        () => {
          setLoading(false);
        }
      )
    );
  };

  return (
    <ModalDialog onClose={onClose} className="create_campaign_dialog">
      <div className="modal_title">
        <Message id="create_gateway" />
      </div>
      <form ref={formRef} onSubmit={onCreate}>
        <div className="campaign_form">
          <div className="dialog_body">
            <input
              ref={inputRef}
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={label(intl, "gateway_name")}
              required
              maxLength="120"
              readOnly={loading}
            />
          </div>
        </div>
        <div className="buttons">
          <button
            type="submit"
            className="btn bg-gradient-dark"
            disabled={loading}
          >
            <Message id="create" />
          </button>
          <button
            type="button"
            className="btn no-btn"
            onClick={onClose}
          >
            <Message id="cancel" />
          </button>
        </div>
      </form>
    </ModalDialog>
  );
};

export default CreateGatewayDialog;
